export class EclesialUsuarioModel {
    public email: string;
    public login: string;
    public nome: string;
}
